import { useState } from "react";
import { Polygon } from "../elements/Polygon";
import MapPropertiesService from '../../services/MapPropertiesService';
import { useDarkmode } from 'components/hooks/useAppStore';
import { useSetMapTitle } from '../../hooks/useMapStore';

interface FairwayAreaFeaturePolygonProps {
    source: any
}
export const FairwayAreaFeaturePolygon = ({
    source
}: FairwayAreaFeaturePolygonProps) => {

    const darkmode = useDarkmode();

    const setMapTitle = useSetMapTitle();

    const mapProperties = MapPropertiesService.properties;

    const [fillOpacity, setFillOpacity] = useState(0.3);

    const fillColor = source.applied ? mapProperties.ColorFairwayAreaApplied : mapProperties.ColorFairwayArea;
    const strokeColor = source.applied ? fillColor : (darkmode ? mapProperties.ColorFairwayAreaStrokeDark : mapProperties.ColorFairwayAreaStroke);
    
    return ( 

        <Polygon
            paths={source.paths}
            fillColor={fillColor}
            fillOpacity={fillOpacity}
            strokeColor={strokeColor}
            strokeWeight={2}
            strokeOpacity={0.8}
            zIndex={1}
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
        />
    );

    function onMouseOver() {
        setFillOpacity(0.6);
        setMapTitle(source.properties.name);
    }

    function onMouseOut() {
        setFillOpacity(0.3);
        setMapTitle("");
    }
}
